import React from "react";
import { clsx } from "clsx";

interface SpinnerProps {
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ className }) => (
  <div
    className={clsx(
      "inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-primary-blue border-r-transparent",
      className
    )}
    role="status"
  />
);
